import { gql } from '@apollo/client'

export const REGISTER_USER_USING_CODE = gql`
  mutation registerUserUsingCode($input: RegisterUserUsingCodeInput!) {
    registerUserUsingCode(input: $input) {
      apiAccessToken {
        tokenString
      }
      errors {
        message
        code
      }
    }
  }
`
